import { Params } from 'app/dataTypes/acquiring/recurrent/deactivate'

import type { Request } from '../../../index'

type ApiParams = {
  saved_bank_card_id: number
}

export const convertParams = ({ bankCardId }: Params): [ApiParams, null] => [
  {
    saved_bank_card_id: parseInt(bankCardId, 10),
  },
  null,
]

type ApiResult = string

export const convertResult = (result: ApiResult): boolean => {
  return !!result
}

export const GET_DEACTIVATE_SAVED_BANK_CARD: Request<Params, boolean, void> = [
  'payments/acquiring2/deactivate_saved_bank_card',
  'get',
  ['data', 'result'],
]
